import React from 'react';
import type { AttentionItem } from '../../domain/types';
import { ProgressBar } from '../../ui/common';

interface JiraCardFooterProps {
  item: AttentionItem;
  isSelected: boolean;
  isExpanded: boolean;
  progress: { done: number; total: number; pct: number };
  onActionClick: (e: React.MouseEvent) => void;
}

export const JiraCardFooter: React.FC<JiraCardFooterProps> = ({
  item,
  isSelected,
  isExpanded,
  progress,
  onActionClick,
}) => {
  const nextStep = item.action || item.next;
  return (
    <div
      className="z-card-actions-row"
      style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}
    >
      {progress.total > 0 ? (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}>
          <span style={{ display: 'inline-block', width: 64 }}>
            <ProgressBar
              progress={progress.pct}
              tone={progress.done === progress.total ? 'ok' : 'accent'}
            />
          </span>
          <span
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 10.5,
              color: 'var(--z-dim)',
            }}
          >
            {progress.done}/{progress.total} AC
          </span>
        </span>
      ) : null}
      {/* Informational only: what the item needs next. It is not a button
          because clicking it does not perform that specific action — see
          openspec/changes/provider-item-interaction-ux (honest controls). */}
      <span
        style={{
          marginLeft: 'auto',
          fontSize: 11,
          color: 'var(--z-faint)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {nextStep || 'en Jira'}
      </span>
      <button
        type="button"
        onClick={onActionClick}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 32,
          padding: '0 15px',
          borderRadius: 999,
          fontSize: 12.5,
          fontWeight: 600,
          cursor: 'pointer',
          background: isSelected ? 'var(--z-accent-soft)' : 'var(--z-plate)',
          color: isSelected ? 'var(--z-accent-ink)' : 'var(--z-muted-2)',
          border: 'none',
        }}
      >
        {isExpanded ? 'Ver detalle' : 'Expandir'}
      </button>
    </div>
  );
};
